import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SessionStorageService } from './@core/common/storage.service';
import { LoginService } from './services/loginservice.service';
import { UserdataService } from './services/userdata.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent implements OnInit{
  title = 'shillong-times';

  constructor(private storage: SessionStorageService, private loginservice: LoginService,
              private router: Router,
              private userdataservice: UserdataService,
  ) {
  }

  ngOnInit() {
    const authToken = this.storage.getItem('token');
    if(authToken){
      this.loginservice.getLogedinCustomerDetails().subscribe(response => {
        if (response.status === 'Success') {
          const data = response.data;
          
          const user = response.data;
          this.userdataservice.setUserData(user);
        } else {
          this.router.navigate(['/register']);
        }
       });
    }
  }
}

